import { Checkbox } from "@ui-kit/Checkbox";
import type { PropertyValueProps } from "./types";

export const FlagPropertyValue = ({ disabled, isAssigned, onSubmit, property }: PropertyValueProps) => (
	<div className="flex h-7 items-center px-1.5">
		<Checkbox
			aria-label={property.name}
			checked={isAssigned}
			disabled={disabled}
			onCheckedChange={() => onSubmit(property.id)}
		/>
	</div>
);
